import React from "react";

const Section5 = () => {
  const testimonials = [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "Marketing Director",
      quote:
        "Working with this team has transformed our brand identity. Their attention to detail and creative approach exceeded our expectations.",
      rating: 5,
    },
    {
      id: 2,
      name: "David Chen",
      role: "Startup Founder",
      quote:
        "The process was seamless from start to finish. They truly understand how to bring visions to life while keeping everything professional and organized.",
      rating: 5,
    },
    {
      id: 3,
      name: "Emma Williams",
      role: "Creative Director",
      quote:
        "Their strategic thinking and design expertise helped us achieve remarkable results. Highly recommended for any business looking to elevate their brand.",
      rating: 5,
    },
  ];

  const renderStars = (rating) => {
    return [...Array(rating)].map((_, index) => (
      <span key={index} className="text-black">
        ★
      </span>
    ));
  };

  return (
    <section className="py-10 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <h2
          className="text-3xl text-center mb-12 tracking-wider"
          style={{
            fontFamily: "Blacker Pro Display",
          }}
        >
          WHAT OUR CLIENTS SAY
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="flex flex-col p-6 rounded-lg shadow-sm"
              style={{ backgroundColor: "#f2efea" }}
            >
              <div className="flex mb-4 text-lg">
                {renderStars(testimonial.rating)}
              </div>

              <blockquote className="flex-grow">
                <p className="text-black italic mb-6 leading-relaxed">
                  "{testimonial.quote}"
                </p>
              </blockquote>

              <div className="mt-auto">
                <p className="font-medium text-black">{testimonial.name}</p>
                <p className="text-sm" style={{ color: "#666" }}>
                  {testimonial.role}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Section5;
